import { render, staticRenderFns } from "./form-page.vue?vue&type=template&id=7c13a66d&"
import script from "./form-page.vue?vue&type=script&lang=js&"
export * from "./form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports